module.exports = __webpack_public_path__ + "static/media/screen6.d4e850eb.png";